export const isPcEnv = process.env.PROJECT_NAME === 'pc'
export const isMobileEnv = process.env.PROJECT_NAME === 'mobile'
